export const scrollToElement = (element: HTMLDivElement) => {
	element.scrollIntoView({
		behavior: 'smooth',
		block: 'nearest',
		inline: 'nearest',
	});
};
